import React from 'react'

export const fontComponents = {
  h1: props => <h1 {...props} />, // eslint-disable-line
  h2: props => <h2 {...props} />, // eslint-disable-line
  h3: props => <h3 {...props} />, // eslint-disable-line
  h4: props => <h4 {...props} />, // eslint-disable-line
  h5: props => <h5 {...props} />, // eslint-disable-line
  h6: props => <h6 {...props} />, // eslint-disable-line
  p: props => <p {...props} />, // eslint-disable-line
  small: props => <small {...props} />, // eslint-disable-line
  xsmall: props => <small {...props} />, // eslint-disable-line
  xxsmall: props => <small {...props} />, // eslint-disable-line
  xxxsmall: props => <small {...props} />, // eslint-disable-line
  label: props => <label {...props} /> // eslint-disable-line
}

// TODO: Define typography
const fontSizes = {
  h1: 3.5,
  h2: 2,
  h3: 1.3,
  h4: 1.2,
  h5: 1,
  h6: 0.875,
  p: 0.875,
  small: 0.75,
  xsmall: 0.625,
  xxsmall: 0.55,
  xxxsmall: 0.45,
  label: 0.875
}

export default fontSizes
